var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompassandx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "60 20 140 180",
    enableBackground: "new 0 0 276.283 226.751",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M173.524,94.783c-0.748,25.871-22.328,46.237-48.199,45.488c-25.868-0.748-46.236-22.327-45.488-48.197 c0.748-25.873,22.33-46.24,48.197-45.492C153.905,47.33,174.274,68.91,173.524,94.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M135.357,39.671c-0.114,3.932-3.392,7.025-7.321,6.91c-3.93-0.113-7.024-3.391-6.91-7.321c0.113-3.931,3.392-7.024,7.322-6.91 C132.377,32.463,135.471,35.741,135.357,39.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M159.8,94.468l4.936,0.143 M89.138,92.425l4.937,0.143 M125.723,126.505l-0.143,4.935 M127.774,55.581l-0.143,4.939  M165.285,94.543c-0.616,21.323-18.401,38.103-39.722,37.487c-21.317-0.617-38.104-18.397-37.486-39.719 c0.615-21.322,18.401-38.105,39.72-37.488C149.116,55.439,165.901,73.222,165.285,94.543z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9F094",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 111.784,113.264 121.196,90.594 138.548,72.007 142.655,75.278 132.368,97.921 114.679,116.149  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 122.231,
    y1: 91.149,
    x2: 130.808,
    y2: 97.352
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 166.189,
    y1: 176.69,
    x2: 180.9,
    y2: 191.177
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#684B94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 180.9,
    y1: 176.69,
    x2: 166.189,
    y2: 191.177
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassandx);
export default __webpack_public_path__ + "static/media/compassandx.de22d642c33e661ea71c549ce8d72703.svg";
export { ForwardRef as ReactComponent };